import { useState } from 'react';
import { categories } from '@/mocks/categories';
import { Link } from 'react-router-dom';

export default function HeroSection() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20arrangement%20of%20premium%20fashion%20items%20including%20textured%20leather%20handbags%2C%20designer%20sneakers%2C%20and%20silk%20accessories%20on%20sculptural%20display%20stands%2C%20soft%20golden%20hour%20studio%20lighting%2C%20luxury%20retail%20editorial%20photography%2C%20warm%20sandstone%20and%20cream%20tones%2C%20sophisticated%20gallery%20composition%20with%20intentional%20negative%20space&width=1800&height=900&seq=hero-bg-v2-main&orientation=landscape"
          alt="Hipobuy Spreadsheet product discovery background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-4xl">
          <p className="text-sm md:text-base font-label text-white/70 tracking-wide mb-4">
            Curated Shopping Intelligence
          </p>
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-6">
            The Most Complete<br />
            Hipobuy Spreadsheet<br />
            Resource Hub
          </h1>
          <p className="text-base md:text-lg font-body text-white/80 max-w-xl mb-8 leading-relaxed">
            Find organized product spreadsheets, verified resources, category guides,
            and comparison tools designed to simplify your shopping research — all in one place.
          </p>

          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 mb-8">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="cta-button inline-flex items-center gap-2 px-6 py-3.5 bg-foreground-900 text-white text-sm md:text-base font-label font-semibold rounded-md whitespace-nowrap hover:bg-foreground-800"
            >
              Start Exploring
              <i className="ri-arrow-right-line text-lg"></i>
            </a>

            <div className="relative">
              <button
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                className="cta-button inline-flex items-center gap-2 px-6 py-3.5 bg-white/15 backdrop-blur-sm text-white border border-white/30 text-sm md:text-base font-label font-semibold rounded-md whitespace-nowrap cursor-pointer hover:bg-white/25 transition-colors"
              >
                View Categories
                <i className={`ri-arrow-down-s-line text-lg transition-transform duration-200 ${isDropdownOpen ? 'rotate-180' : ''}`}></i>
              </button>

              {isDropdownOpen && (
                <div className="absolute top-full left-0 mt-2 w-[640px] bg-background-50 rounded-lg overflow-hidden z-50"
                  style={{ boxShadow: '0 4px 24px rgba(0,0,0,0.1)' }}
                >
                  <div className="grid grid-cols-3 gap-1 p-3">
                    {categories.map((cat) => (
                      <a
                        key={cat.name}
                        href={cat.url}
                        target="_blank"
                        rel="noopener nofollow"
                        className="flex items-center gap-2.5 px-3 py-2.5 rounded-md text-sm font-body text-foreground-700 hover:text-foreground-900 hover:bg-background-100 transition-colors whitespace-nowrap"
                        onClick={() => setIsDropdownOpen(false)}
                      >
                        <span className="w-5 h-5 flex items-center justify-center">
                          <i className={`${cat.icon} text-primary-500 text-sm`}></i>
                        </span>
                        {cat.name}
                      </a>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-2 md:gap-3">
            {categories.slice(0, 4).map((cat) => (
              <a
                key={cat.name}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-white/10 backdrop-blur-sm text-white/90 text-xs font-label font-medium rounded-full border border-white/20 whitespace-nowrap hover:bg-white/20 transition-colors"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className={`${cat.icon} text-xs`}></i>
                </span>
                {cat.name}
              </a>
            ))}
            <span className="text-white/50 text-xs font-label">+10 more categories</span>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 to-transparent z-10"></div>
    </section>
  );
}